import React, { useEffect, useState, useContext } from 'react';
import { Row, Col, Card, Progress, message, Tooltip, Modal, Table, Button } from 'antd';
import * as Utilities from '../../Utilities';
import axios from 'axios';
import FileConstants from '../../../../FileConstants';
import ENVIRONMENT from '../../../../environments';
import DottedLoader from '../../DottedLoader';
import { ArrowUpOutlined, InfoCircleOutlined, LoadingOutlined, UpOutlined } from '@ant-design/icons';
import QuotaContext from "../../ContextFiles/QuotaContext";
import { nextSubscription } from '../PricingModals/data/data';


/*
Dictionary to maintain cards organization for displaying data
Format: {
    First Section Heading: {
        key: sub_display_heading,
        key2: second_card_heading
    },
    Second Section Heading: {
        key: sub_display_heading,
        key2: second_card_heading
    },

}
*/
const cardsOrganization = {
    'Usage Details': {
        'ai_model': {
            'name': 'Product uploads / AI Videos',
            'similar_requests': [
                'ai_model'
            ],
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Model ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/products/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Category",
                dataIndex: "category",
                key: "category",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            }]
        },
        'ai_models': {
            'name': 'Total Credits',
            'show_tooltip': true,
            'show_details': false,
            'progress_display_type': 'descriptive',
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Model ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/products/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Category",
                dataIndex: "category",
                key: "category",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            }]
        },
        'product_model': {
            'name': 'Photorealistic Models',
            'similar_requests': [
                'product_model'
            ],
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Model ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/products/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Category",
                dataIndex: "category",
                key: "category",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            }]
        },
        'scene_lifestyle_image': {
            'name': 'Total credits',
            'show_tooltip': true,
            'show_details': false,
            'progress_display_type': 'descriptive',
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Scene ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/scene_renders/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            },
            {
                title: "Render Name",
                dataIndex: "render_name",
                key: "render_name",
            },
            {
                title: "Resolution",
                dataIndex: "render_resolution",
                key: "render_resolution",
            }]
        },
        'ai_image_4k': {
            'name': 'AI final images (4K)',
            'show_tooltip': true,
            'show_details': false,
            'progress_display_type': 'descriptive',
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Scene ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/scene_renders/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            },
            {
                title: "Render Name",
                dataIndex: "render_name",
                key: "render_name",
            },
            {
                title: "Resolution",
                dataIndex: "render_resolution",
                key: "render_resolution",
            }]
        },
        'product_silo': {
            'name': 'Product Images',
            'show_tooltip': true,
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Model ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/products/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            },
            {
                title: "Render Name",
                dataIndex: "render_name",
                key: "render_name",
            },
            {
                title: "Resolution",
                dataIndex: "render_resolution",
                key: "render_resolution",
            }]
        },
        'variation_product_model': {
            'name': 'Product Variations',
            'similar_requests': [
                'variation_product_model'
            ],
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Model ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/products/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Category",
                dataIndex: "category",
                key: "category",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            }]
        },
        'ai_image_1k': {
            'name': 'AI image previews (1K)',
            'similar_requests': [
                'ai_image_1k'
            ],
            'show_details': false,
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Model ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/products/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Category",
                dataIndex: "category",
                key: "category",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            }]
        }
    },
    'Modeling and Rendering Services': {
        'product_model': {
            'name': 'Product Models',
            'info': 'Overall Product Models requested.',
            'show_tooltip': true,
            'similar_requests': [
                'product_model'
            ],
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Model ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/products/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Category",
                dataIndex: "category",
                key: "category",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            }]
        },
        'product_model_high_res': {
            'name': 'Product Models / Variants',
            'info': 'Variant are counted as half of the product model.',
            'show_tooltip': true,
            'similar_requests': ['product_model_high_pbr',
                'product_model_high_pbr_and_ar',
                'product_model_ar',
                'product_model_high_res',
                'variation_product_model',
                'product_model_high_res_and_ar'
            ],
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Model ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/products/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Category",
                dataIndex: "category",
                key: "category",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            }]
        },
        'room_model': {
            'name': 'Space Models',
            'show_tooltip': true,
            'similar_requests': [
                'variation_room_model',
                'room_model'
            ],
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Space ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/rooms/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Category",
                dataIndex: "category",
                key: "category",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            }]
        },
        'variation_room_model': {
            'name': 'Space Variants',
            'show_tooltip': true,
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Space ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/rooms/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Category",
                dataIndex: "category",
                key: "category",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            }]
        },
        'create_new_material': {
            'name': 'Materials',
            'show_tooltip': true,
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Material ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                "/material-library"
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Category",
                dataIndex: "category",
                key: "category",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            }]
        },
        'existing_product_model': {
            'name': 'Customer Uploaded Models',
            'show_tooltip': true,
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Model ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/products/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Category",
                dataIndex: "category",
                key: "category",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            }]
        },
        'scene_lifestyle_image': {
            'name': 'Lifestyle Renders',
            'show_tooltip': true,
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Scene ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/scene_renders/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            },
            {
                title: "Render Name",
                dataIndex: "render_name",
                key: "render_name",
            },
            {
                title: "Resolution",
                dataIndex: "render_resolution",
                key: "render_resolution",
            }]
        },
        'product_silo': {
            'name': 'Silo Renders',
            'show_tooltip': true,
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Model ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/products/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            },
            {
                title: "Render Name",
                dataIndex: "render_name",
                key: "render_name",
            },
            {
                title: "Resolution",
                dataIndex: "render_resolution",
                key: "render_resolution",
            }]
        },
        'product_managed_lifestyle': {
            'name': 'Design Service Scene',
            'show_tooltip': true,
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Scene ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/scene_renders/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            }]
        },
        'designer_time': {
            'name': 'Design Service Hours',
            'show_tooltip': true,
            'detail_fields': []
        },
    },
    'All3D Store': {
        'product_prop': {
            'name': 'Product Props',
            'show_tooltip': true,
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Model ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/products/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Category",
                dataIndex: "category",
                key: "category",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            }]
        },
        'room_prop': {
            'name': 'Space Props',
            'show_tooltip': true,
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Space ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/rooms/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Category",
                dataIndex: "category",
                key: "category",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            }]
        },
        'scene_template_prop': {
            'name': 'ALL3D Templates',
            'show_tooltip': true,
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Scene ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/scene_renders/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            }]
        }
    },
    'Other Services': {
        '3d_tour': {
            'name': '3D Tours',
            'show_tooltip': true,
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Scene ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/scene_renders/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            }]
        },
        'product_360_spin': {
            'name': 'Product 360',
            'show_tooltip': true,
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Model ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/products/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            },
            {
                title: "Resolution",
                dataIndex: "render_resolution",
                key: "render_resolution",
            }]
        },
        'product_dimensional': {
            'name': 'Product Dimensional',
            'show_tooltip': true,
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Model ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/products/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            },
            {
                title: "Resolution",
                dataIndex: "render_resolution",
                key: "render_resolution",
            }]
        },
        'product_video': {
            'name': 'Product Videos',
            'show_tooltip': true,
            'detail_fields': [{
                title: "Username",
                dataIndex: "customer_username",
                key: "customer_username",
            },
            {
                title: "Model ID",
                dataIndex: "entity_id",
                key: "entity_id",
                render: (_, record) => (
                    <span>
                        <a
                            target="_blank"
                            className="onhover-underline"
                            href={
                                `/products/` + record.entity_id
                            }
                        >
                            {record.entity_id}
                        </a>
                    </span>
                ),
            },
            {
                title: "Name",
                dataIndex: "name",
                key: "name",
            },
            {
                title: "Date",
                dataIndex: "request_time",
                key: "request_time",
            },
            {
                title: "Resolution",
                dataIndex: "render_resolution",
                key: "render_resolution",
            }]
        },
    }
}


const UsageQuotaDetail = () => {
    const { key, item, index, quota_details, plan_data, openPricingPlansModal, openUpgradeModal } = useContext(QuotaContext);

    const [currentServiceDisplayName, setCurrentServiceDisplayName] = useState('');
    const [serviceSpecificUsageDetailsModal, setServiceSpecificUsageDetailsModal] = useState(false);
    const [isTableDataLoading, setIsTableDataLoading] = useState(false);
    const [usageTableColumns, setUsageTableColumns] = useState([]);
    const [serviceUsageTableData, setServiceUsageTableData] = useState([]);

    const getProgressBarColor = (item, quota_details) => {
        // This function returns a string of color code for the progress bar 
        // depending on the used quota.
        let color_string = '#1890FF' // blue, default color for percentage used less then 50
        let percentage_used = Utilities.getFormattedStringOrPercentage(item, 'percentage', quota_details);

        return color_string
    }

    const servicesWithoutProgress = ['ai_image_4k', 'ai_image_1k'];

    const openServiceUsageDetails = (service) => {
        setIsTableDataLoading(true);
        Object.keys(cardsOrganization).map(key => {
            Object.keys(cardsOrganization[key]).map(requestkey => {
                if (requestkey == service) {
                    let requestDetails = cardsOrganization[key][requestkey];
                    loadServiceUsageDetailsData(service, requestDetails)
                }
            })
        })
    }

    const loadServiceUsageDetailsData = (service, requestDetails) => {

        let requestTypesForPayload = requestDetails['similar_requests'] ?? [service]
        let serviceUsageSummaryText = Utilities.getFormattedStringOrPercentage(service, 'formatted_string', quota_details);
        let remainingQuotaText = Utilities.getFormattedStringOrPercentage(service, 'remaining_quota_string', quota_details);
        let serviceUsageFormattedText = (serviceUsageSummaryText + (remainingQuotaText != '' ? (' (' + remainingQuotaText + ')') : ''));
        setCurrentServiceDisplayName(requestDetails['name'] + ' - ' + serviceUsageFormattedText);
        setServiceSpecificUsageDetailsModal(true);
        let payload = {
            'customer_username': localStorage.getItem('username'),
            'request_types': requestTypesForPayload
        }

        axios.post(ENVIRONMENT.GET_SUBSCRIPTION_AVAILED_ENTITIES, payload)
            .then((response) => {
                let dataRecords = []
                for (let row of response.data) {
                    dataRecords.push({
                        'subscription_id': row.subscription_id,
                        'request_type': row.request_type,
                        'request_category': row.request_category,
                        'name': row.name,
                        'category': row.category,
                        'entity_type': row.entity_type,
                        'entity_id': row.entity_id,
                        'render_name': row.render_name,
                        'render_resolution': row.render_resolution,
                        'request_time': Utilities.convertUtcToLocalTimezone(row.request_time),
                        'customer_username': row.customer_username
                    });
                }
                setUsageTableColumns(requestDetails['detail_fields'])
                setServiceUsageTableData(dataRecords);
                setIsTableDataLoading(false);
            })
    }


    return (
        <>
            <Col span={24}>
                <div className="justify-space-between">
                    <div className='justify-in-start usage-quota-detail-card'>
                        <span className='manrope f-14 lh-22 w-700 black-085' style={{ flex: 1, whiteSpace: "nowrap" }}>{cardsOrganization[key][item]['name']}</span>
                        {servicesWithoutProgress.includes(item) ? (
                            <div style={{ flex: 2 }}></div>
                        ) : (
                            <Progress style={{ flex: 2 }} showInfo={false} trailColor="#d9d9d9" strokeColor={getProgressBarColor(item, quota_details)} size={[500, 20]} percent={Utilities.getFormattedStringOrPercentage(item, 'percentage', quota_details)}></Progress>
                        )}
                        <div style={{ flex: 1 }}>
                            <Tooltip title={<span className='manrope f-12 white'>{Utilities.getFormattedStringOrPercentage(item, 'tooltip', quota_details)}</span>}>
                                <a className={`manrope f-14 lh-22 ${Utilities.getFormattedStringOrPercentage(item, 'percentage', quota_details) == 100 ? 'w-700 blue-18 blue-19-hover' : 'w-500 black-085 blck-hover'}`}
                                    onClick={() => cardsOrganization[key][item]['show_details'] !== false && openServiceUsageDetails(item)}
                                    style={{ 
                                        whiteSpace: "nowrap",
                                        cursor: cardsOrganization[key][item]['show_details'] === false ? 'default' : 'pointer',
                                        pointerEvents: cardsOrganization[key][item]['show_details'] === false ? 'none' : 'auto'
                                    }}>{Utilities.getFormattedStringOrPercentage(item, 'formatted_string', quota_details)}</a>
                            </Tooltip>
                        </div>
                        {cardsOrganization[key][item]['name'] == 'Product uploads / AI Videos' ?
                        <div style={{ flex: 1 }} className="justify-in-end">
                            {plan_data?.display_name == 'Free Trial' ? '' :
                            <span className='manrope f-14 lh-22 w-500 black-085' style={{ whiteSpace: "nowrap", opacity: 0.6 }}>4 credits per model / 2 credits per video</span>}
                        </div> : 
                        cardsOrganization[key][item]['name'] == 'Total credits' ? 
                        <div style={{ flex: 1 }} className="justify-in-end">
                            {plan_data?.offering_type == 'bundle' && Utilities.getFormattedStringOrPercentage(item, 'percentage', quota_details) >= 80 ? (
                                <Button className='subscribe-save-button' onClick={() => openPricingPlansModal('subscriptions')}>
                                    <ArrowUpOutlined style={{ transform: 'rotate(45deg)'}} className={'manrope f-14'} />
                                    Subscribe & save 
                                </Button>
                            ) : plan_data?.offering_type == 'subscription' && Utilities.getFormattedStringOrPercentage(item, 'percentage', quota_details) >= 90 && nextSubscription[plan_data?.display_name] ? (
                                <Button className='subscribe-save-button' onClick={openUpgradeModal}>
                                    <ArrowUpOutlined style={{ transform: 'rotate(45deg)'}} className={'manrope f-14'} />
                                    Upgrade to {nextSubscription[plan_data?.display_name]?.display_name}
                                </Button>
                            ) : null}
                        </div> : <div style={{ flex: 1 }} className="justify-in-end">
                        </div>}
                    </div>
                </div>
            </Col>

            <Modal
                title={currentServiceDisplayName}
                maskClosable={false}
                onCancel={() => setServiceSpecificUsageDetailsModal(false)}
                visible={serviceSpecificUsageDetailsModal}
                width={"70%"}
                centered={true}
                style={{ paddingTop: 20, minWidth: "80%" }}
                footer={null}>
                {isTableDataLoading ? (
                    <LoadingOutlined className="loading-center" />
                ) : (
                    <Table
                        dataSource={serviceUsageTableData}
                        columns={usageTableColumns}
                        scroll
                    />
                )}
            </Modal>
        </>
    )
}

export default UsageQuotaDetail;